export const ANNUAL_DECLARATION_YEAR = 2026;

export const ANNUAL_DECLARATION_PRODUCT_CATEGORY = 'Declaración Anual';

export const ANNUAL_DECLARATION_BENEFITS = [
	'Un contador dedicado para resolver tus dudas antes de presentar',
	'Análisis detallado de tu declaración con acuse incluido',
	'Gestión de tu devolución ante el SAT si tienes saldo a favor',
	'IA avanzada para optimizar tu resultado a tu favor',
];

export const ANNUAL_DECLARATION_DESCRIPTION =
	'Cubre la presentación de tu declaración anual 2026, con vencimiento en abril de 2027. Anticípate y asegura una preparación a tiempo.';
